module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap home-wrap flex-column"
  }, [_c('topLink'), _vm._v(" "), (_vm.load) ? _c('mu-infinite-scroll', {
    staticClass: "load",
    attrs: {
      "loading": _vm.load,
      "loadingText": "拼命加载中"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-box",
    class: {
      fixed: _vm.scrolled > 0
    }
  }, [_c('input', {
    staticClass: "serarch-input",
    attrs: {
      "readonly": "",
      "type": "text",
      "name": "",
      "placeholder": "搜索商品"
    },
    on: {
      "click": _vm.searchGood
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.load),
      expression: "!load"
    }],
    ref: "homeWrapper",
    staticClass: "flex-item homeWrapper"
  }, [_c('div', {
    staticClass: "banner"
  }, [_c('swiper', {
    ref: "mySwiper1",
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.slides), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.linkFn(item.linkType, item.linkTarget)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "width": 720,
        "imagePath": item.imagePath && item.imagePath.imagePath
      }
    })], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-brand"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "brand-item square",
    on: {
      "click": function($event) {
        return _vm.linkFn('fitting', '')
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/icon_sgtd.jpg"
    }
  }), _vm._v(" "), _c('p', [_vm._v("诚邀合伙人")])]), _vm._v(" "), _vm._l((_vm.brandCates), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "brand-item square",
      on: {
        "click": function($event) {
          return _vm.linkFn(item.cates.linkType, item.cates.linkTarget)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "imagePath": item.cates &&
          item.cates.imagePath &&
          item.cates.imagePath.imagePath,
        "width": 120,
        "height": 120,
        "imgStyle": {
          margin: '0 auto'
        }
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cates.linkName))])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "brand-item square",
    on: {
      "click": function($event) {
        return _vm.linkFn('oa', '')
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("办公门户")])]), _vm._v(" "), _c('div', {
    staticClass: "brand-item square",
    on: {
      "click": function($event) {
        return _vm.$router.push('/main/diyPage')
      }
    }
  }, [_vm._m(2), _vm._v(" "), _c('p', [_vm._v("DIY")])]), _vm._v(" "), _c('div', {
    staticClass: "brand-item square",
    on: {
      "click": function($event) {
        return _vm.$router.push('/main/install-study')
      }
    }
  }, [_vm._m(3), _vm._v(" "), _c('p', [_vm._v("安装指导")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "recommend"
  }, [_c('h2', [_vm._v("精品推荐")]), _vm._v(" "), _c('div', {
    staticClass: "banner-recommend"
  }, [_c('swiper', {
    ref: "mySwiper2",
    attrs: {
      "options": _vm.comSwiperOption
    }
  }, _vm._l((_vm.boutiques), function(item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "img-box",
      on: {
        "click": function($event) {
          return _vm.viewGoodsDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "img"
    }, [_c('v-image', {
      attrs: {
        "width": 250,
        "height": 250,
        "imagePath": item.imagePath && item.imagePath.imagePath
      }
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "title ellipsis"
    }, [_vm._v(_vm._s(item.goodsName))]), _vm._v(" "), _c('p', {
      staticClass: "money"
    }, [(item.goodsPrice > 0) ? _c('samp', [_vm._v("¥")]) : _vm._e(), _vm._v("\n                " + _vm._s(item.goodsPrice > 0 ? item.goodsPrice : item.goodDesc) + "\n                "), (item.unitPrice > 0) ? _c('span', [_vm._v("¥ " + _vm._s(item.unitPrice))]) : _vm._e()])])])
  }), 1)], 1)]), _vm._v(" "), _vm._l((_vm.floors), function(item, index) {
    return _c('div', {
      staticClass: "brand-product"
    }, [(item.itemType == 99) ? _c('a', {
      staticClass: "banner-product",
      on: {
        "click": function($event) {
          return _vm.linkFn(item.floorInfo.linkType, item.floorInfo.linkTarget)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "width": 720,
        "imagePath": item.floorInfo &&
          item.floorInfo.imagePath &&
          item.floorInfo.imagePath.imagePath,
        "eventparam": item
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.floorInfo.goods && item.floorInfo.goods.length) ? _c('a', {
      staticClass: "header",
      on: {
        "click": function($event) {
          return _vm.linkFn(item.floorInfo.linkType, item.floorInfo.storeId)
        }
      }
    }, [_c('span', {
      staticClass: "floatL brandName"
    }, [_vm._v("\n          " + _vm._s(item.floorName) + "\n        ")]), _vm._v(" "), _c('span', {
      staticClass: "floatR arrow"
    }, [_vm._v("更多")]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "product"
    }, _vm._l((item.floorInfo.goods), function(goods, index) {
      return _c('div', {
        staticClass: "product-item square"
      }, [_c('v-image', {
        attrs: {
          "width": 250,
          "height": 250,
          "titleText": goods.goodsName,
          "imagePath": goods.imagePath && goods.imagePath.imagePath,
          "moneyText": goods.goodsPrice > 0 ? goods.goodsPrice : goods.priceDesc || '',
          "orginalCost": goods.unitPrice,
          "eventparam": goods
        },
        on: {
          "eventclick": _vm.viewGoodsDetail
        }
      }, [_c('template', {
        slot: "money"
      }, [_vm._v("\n              " + _vm._s(goods.goodsPrice > 0 ? goods.goodsPrice : goods.priceDesc) + "\n            ")]), _vm._v(" "), _c('template', {
        slot: "orginalCost"
      }, [_vm._v(_vm._s(goods.unitPrice))])], 2)], 1)
    }), 0)])
  }), _vm._v(" "), _c('div', {
    staticClass: "brand-product bottom"
  }, [(_vm.ShareGoods.length > 0) ? _c('a', {
    staticClass: "header",
    on: {
      "click": _vm.gotosunhomeList
    }
  }, [_c('span', {
    staticClass: "floatL brandName"
  }, [_vm._v("晒家分享")]), _vm._v(" "), _c('span', {
    staticClass: "floatR arrow"
  }, [_vm._v("更多")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.ShareGoods), function(item) {
    return _c('div', {
      staticClass: "floatL left-advertise"
    }, [_c('div', {
      staticClass: "img",
      on: {
        "click": function($event) {
          return _vm.gotoSunhomeDetail(item.shareId)
        }
      }
    }, [_c('v-image', {
      attrs: {
        "titleText": item.shareContent,
        "imagePath": item && item.imagePath && item.imagePath.imagePath
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "userName ellipsis"
    }, [_vm._v("来自 " + _vm._s(item.shareBy) + " 的评价")]), _vm._v(" "), _c('p', {
      staticClass: "style-box"
    }, [_c('span', {
      staticClass: "style ellipsis"
    }, [_vm._l((item.tags), function(sub) {
      return [_vm._v("\n                " + _vm._s(sub.linkName) + " \n              ")]
    })], 2), _vm._v(" "), (item.totalPrice > 0) ? _c('span', {
      staticClass: "price ellipsis"
    }, [_vm._v("\n              " + _vm._s(item.totalPrice) + "元\n            ")]) : _vm._e()])], 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })], 2)], 2), _vm._v(" "), _c('menus')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "brand-item square",
    attrs: {
      "href": "tel:023-62797973"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/project-icon.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("工厂直供")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "square",
    staticStyle: {
      "width": "100%",
      "font-size": "0",
      "border-radius": "0.333333rem",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/oaLogo.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "square",
    staticStyle: {
      "width": "100%",
      "font-size": "0",
      "border-radius": "0.333333rem",
      "overflow": "hidden"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/diyLogo.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "square",
    staticStyle: {
      "width": "100%",
      "font-size": "0",
      "border-radius": "0.333333rem",
      "overflow": "hidden",
      "background-color": "yellow"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/images/install-study.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-438de1f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/home.vue
// module id = 395
// module chunks = 68